

document.addEventListener('DOMContentLoaded', () => {
  const dropdowns = document.querySelectorAll('.header__submenu--split');

  dropdowns.forEach((dropdown) => {
    const leftLinks = Array.from(dropdown.querySelectorAll('.dropdown-left [data-submenu-trigger]'));
    const rightPanels = Array.from(dropdown.querySelectorAll('.dropdown-right [data-submenu-panel]'));
    const details = dropdown.closest('details');

    if (!leftLinks.length || !rightPanels.length) return;

    const setActivePanel = (panelId) => {
      rightPanels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.classList.toggle('is-visible', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      leftLinks.forEach((link) => {
        const isActive = link.dataset.submenu === panelId;
        link.classList.toggle('is-active', isActive);
        link.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    };

    const activateFirstPanel = () => {
      const firstPanelId = leftLinks[0]?.dataset.submenu;
      if (firstPanelId) setActivePanel(firstPanelId);
    };

    leftLinks.forEach((link) => {
      const panelId = link.dataset.submenu;
      if (!panelId) return;

      link.addEventListener('mouseenter', () => setActivePanel(panelId));
      link.addEventListener('focus', () => setActivePanel(panelId));
    });

    dropdown.addEventListener('mouseleave', () => {
      if (details?.open) activateFirstPanel();
    });

    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open) {
          activateFirstPanel();
        } else {
          rightPanels.forEach((panel) => {
            panel.classList.remove('is-visible');
            panel.setAttribute('aria-hidden', 'true');
          });
          leftLinks.forEach((link) => {
            link.classList.remove('is-active');
            link.setAttribute('aria-expanded', 'false');
          });
        }
      });

      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          details.removeAttribute('open');
          details.querySelector('summary')?.focus();
        }
      });
    } else {
      activateFirstPanel();
    }
  });
});
